import { useEffect, useRef, useState } from "react";
import getRolesService from "../../api/Role/GetRoles/getRolesService";
import { IRoles } from "../../components/Admin/Role/IRole";
import { header } from "../../context/constant";
export const defaultRole: IRoles[] = [];
const useGetRoles = () => {
  const [roles, setRoles] = useState<IRoles[]>(defaultRole);
  const isLoading = useRef(true);
  useEffect(() => {
    if (isLoading.current) {
      getRolesService({ header })
        .then((apiResponse) => {
          isLoading.current = false;
          setRoles(apiResponse.data!);
        })
        .catch((res) => {
          console.error(res.status);
        });
    }
    // eslint-disable-next-line
  }, [header, isLoading]);
  return [roles];
};
export default useGetRoles;
